import {ShadowEditorValue} from '@app/editor/editor-sidebar/inspector-panel/shadow-editor/shadow-editor-value';

export const defaultBoxShadow: ShadowEditorValue = {
  type: 'box',
  color: 'rgba(0,0,0,0.2)',
  angle: 0,
  distance: 2,
  blur: 5,
  spread: 0,
  inset: false,
};
